export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/tour/front/travel/order-success',
      name: 'distributor-tour-front-travel-order-success',
      component: () => import('./index.vue'),
    },
  ]
};
